import {FC} from "react";
import {Editor} from "@tiptap/react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
  faAlignCenter,
  faAlignJustify, faAlignLeft, faAlignRight, faBold,
  faFileDashedLine, faItalic,
  faLink,
  faList12,
  faListDots, faStrikethrough, faUnderline,
  faUnlink
} from "@fortawesome/pro-light-svg-icons";

export const TopMenuBar: FC<{ editor: Editor }> = ({ editor }) => {

  if (!editor) {
    return null;
  }

  const baseStyle = 'h-10 bg-brand-50 px-3 py-0.5 border hover:bg-brand-200 hover:cursor-pointer'
  const activeButtonStyle = 'border-brand-900 bg-brand-100'
  const inactiveButtonStyle = 'border-slate-200'

  return <div className={'flex flex-1 bg-brand-50'}>
    <div className="control-group">
      <div className="button-group">
        <button
          onClick={() => editor.chain().focus().toggleHeading({ level: 1 }).run()}
          className={`font-medium ${baseStyle} ${editor.isActive('heading', { level: 1 }) ? activeButtonStyle : inactiveButtonStyle}`}
        >
          H1
        </button>
        <button
          onClick={() => editor.chain().focus().toggleHeading({ level: 2 }).run()}
          className={`font-medium ${baseStyle} ${editor.isActive('heading', { level: 2 }) ? activeButtonStyle : inactiveButtonStyle}`}
        >
          H2
        </button>
        <button
          onClick={() => editor.chain().focus().toggleBold().run()}
          className={`${baseStyle} ${editor.isActive('bold') ? activeButtonStyle : inactiveButtonStyle}`}
        >
          <FontAwesomeIcon icon={faBold} />
        </button>
        <button
          onClick={() => editor.chain().focus().toggleItalic().run()}
          className={`${baseStyle} ${editor.isActive('italic') ? activeButtonStyle : inactiveButtonStyle}`}
        >
          <FontAwesomeIcon icon={faItalic} />
        </button>
        <button
          onClick={() => editor.chain().focus().toggleUnderline().run()}
          className={`${baseStyle} ${editor.isActive('underline') ? activeButtonStyle : inactiveButtonStyle}`}
        >
          <FontAwesomeIcon icon={faUnderline} />
        </button>
        <button
          onClick={() => editor.chain().focus().toggleStrike().run()}
          className={`${baseStyle} ${editor.isActive('strike') ? activeButtonStyle : inactiveButtonStyle}`}
        >
          <FontAwesomeIcon icon={faStrikethrough} />
        </button>
        <button
          onClick={() => editor.chain().focus().setTextAlign('left').run()}
          className={`${baseStyle} ${editor.isActive({ textAlign: 'left' }) ? activeButtonStyle : inactiveButtonStyle}`}
        >
          <FontAwesomeIcon icon={faAlignLeft} />
        </button>
        <button
          onClick={() => editor.chain().focus().setTextAlign('center').run()}
          className={`${baseStyle} ${editor.isActive({ textAlign: 'center' }) ? activeButtonStyle : inactiveButtonStyle}`}
        >
          <FontAwesomeIcon icon={faAlignCenter} />
        </button>
        <button
          onClick={() => editor.chain().focus().setTextAlign('right').run()}
          className={`${baseStyle} ${editor.isActive({ textAlign: 'right' }) ? activeButtonStyle : inactiveButtonStyle}`}
        >
          <FontAwesomeIcon icon={faAlignRight} />
        </button>
        <button
          onClick={() => editor.chain().focus().setTextAlign('justify').run()}
          className={`${baseStyle} ${editor.isActive({ textAlign: 'justify' }) ? activeButtonStyle : inactiveButtonStyle}`}
        >
          <FontAwesomeIcon icon={faAlignJustify} />
        </button>
        {/*<button*/}
        {/*  onClick={() => editor.commands.insertContent('\\newpage\\')}*/}
        {/*  className={`${baseStyle} ${inactiveButtonStyle}`}*/}
        {/*>*/}
        {/*  <FontAwesomeIcon icon={faFileDashedLine} />*/}
        {/*</button>*/}
        <button
          onClick={() => {
            const success = editor.chain().focus().toggleBulletList().run()
          }}
          className={`${baseStyle}`}
        >
          <FontAwesomeIcon icon={faListDots} />
        </button>
        <button
          onClick={() => editor.chain().focus().toggleOrderedList().run()}
          className={`${baseStyle} ${inactiveButtonStyle}}`}
        >
          <FontAwesomeIcon icon={faList12} />
        </button>
        {/*<button*/}
        {/*  onClick={() => {*/}
        {/*    const link = prompt('URL')*/}
        {/*    if (link) {*/}
        {/*      editor.commands.setLink({ href: link, target: '_blank' })*/}
        {/*    }*/}
        {/*  }}*/}
        {/*  className={`${baseStyle} ${inactiveButtonStyle}`}*/}
        {/*>*/}
        {/*  <FontAwesomeIcon icon={faLink} />*/}
        {/*</button>*/}
        {/*<button*/}
        {/*  onClick={() => editor.commands.unsetLink()}*/}
        {/*  className={`${baseStyle} ${inactiveButtonStyle}`}*/}
        {/*>*/}
        {/*  <FontAwesomeIcon icon={faUnlink} />*/}
        {/*</button>*/}
      </div>
    </div>
  </div>
}